import { motion } from "framer-motion";
import { Award, Users, Calendar, ThumbsUp } from "lucide-react";
import marbleBg from "@/assets/marble-bg.jpg";

const stats = [
  { icon: Calendar, value: "+15", label: "سنة خبرة" },
  { icon: Award, value: "+1000", label: "مشروع منجز" },
  { icon: Users, value: "+1000", label: "عميل سعيد" },
  { icon: ThumbsUp, value: "100%", label: "رضا العملاء" },
];

const AboutSection = () => {
  return (
    <section id="about" className="relative section-padding overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <img src={marbleBg} alt="" className="w-full h-full object-cover" loading="lazy" width={1920} height={1080} />
      </div>
      <div className="relative container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="w-12 h-0.5 gold-gradient mb-4" />
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6">خبرة وجودة تتحدث عنّا</h2>
            <p className="text-muted-foreground leading-relaxed mb-6 text-lg">
              حسن عبدالله للمقاولات والديكورات — من أبرز الشركات المتخصصة في التصميم الداخلي والمقاولات بمدينة الرياض.
              خبرة تمتد لأكثر من ١٥ عامًا في تحويل المساحات إلى بيئات فاخرة تجمع بين الجمال والعملية.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-8 text-lg">
              نلتزم بأعلى معايير الجودة في كل مشروع — من الديكورات والتصميم الداخلي إلى الترميم والدهانات والمقاولات العامة.
              فريقنا المتخصص يعمل بشغف لتحقيق رؤيتكم وتجاوز توقعاتكم.
            </p>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 text-primary font-semibold hover:text-gold-dark transition-colors text-lg"
            >
              تواصل معنا ←
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="grid grid-cols-2 gap-6"
          >
            {stats.map((stat, i) => (
              <motion.div
                key={stat.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.3 + i * 0.1 }}
                className="bg-card rounded-lg p-6 text-center border border-border hover:border-primary/40 transition-all duration-300"
              >
                <stat.icon className="w-8 h-8 text-primary mx-auto mb-3" />
                <div className="text-3xl font-bold gold-text mb-1">{stat.value}</div>
                <div className="text-sm text-muted-foreground">{stat.label}</div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
